export function BlogPost({
  link = '#',
  style = '',
  title,
  date,
  readTime,
  subtype,
  type,
  color,
  summary,
  image,
  authorTag = '',
  buttonText = 'Read more',
  isEvent = false,
  eventDate = null,
  eventDatePrefix = '',
  eventStartTime = null,
  eventEndTime = null,
}) {
  // check if image is an svg
  const isSvg = image && image.url && image.url.includes('.svg')

  return /*html*/ `
        <article class="c-card-item c-card-item--4" style="${style}">
            <a href="${link}" class="c-card-item-link" aria-label="${title}"></a>

            <picture class="c-card-item-picture${isSvg ? ' -is-svg' : ''} -color-${color} ${!image ? '-has-icon' : ''}">
                ${
                  image
                    ? `<img src="${image.url}" alt="${image.alt}">`
                    : `<img class="-blog-icon" src="/assets/images/blog/blog15.svg" alt="${title}">`
                }
            </picture>

            <span class="c-card-item-content">
                <span class="c-card-item-content-details">
                    <span class="ts-eyebrow">${subtype ?? type}</span>
                    ${
                      isEvent
                        ? `${
                            eventDate && eventStartTime
                              ? `
                              <span class="ts-indicator">
                                  ${eventDate ? `<span class="ts-detail">${eventDatePrefix} ${eventDate}</span>` : ''}
                                  ${
                                    eventStartTime
                                      ? `<span class="ts-detail">${eventStartTime} ${eventEndTime ? ` - ${eventEndTime}` : ''}</span>`
                                      : ''
                                  }
                              </span>
                            `
                              : ''
                          }`
                        : `
                        <span class="ts-indicator">
                            ${date ? `<span class="ts-detail">${date}</span>` : ''}
                        </span>
                      `
                    }
                </span>
                <h3 class="ts-4">${title}</h3>

                <span class="ts-p">
                  ${summary}
                </span>

                <span class="c-card-item-footer">
                  ${authorTag}
                  ${readTime ? `<span class="c-card-item-readtime ts-detail">${readTime}</span>` : ''}
                </span>
            </span>
        </article>`
}
